<template>
  <div class="search-bar col-md-6 col-sm-12" v-if="searchActive">
    <i class="icon-search"></i>
    <input
      ref="searchInput"
      type="text"
      placeholder="Search ideas"
      @blur="blurClose"
      v-model="searchTextComponent"
      @keydown="updateSearchText"
      @input="updateSearchText"
    />
    <i class="icon-close" @click="resetSearch"></i>
  </div>
</template>

<script>
import bus from "../../bus";

export default {
  data() {
    return {
      searchTextComponent: "",
      searchActive: false,
    };
  },
  methods: {
    updateSearchText: function () {
      bus.$emit(this.eventName, this.searchTextComponent);
    },
    blurClose: function () {
      if (this.searchTextComponent == "") {
        this.searchActive = false;
      }
    },
    resetSearch: function () {
      this.searchTextComponent = "";
      this.updateSearchText();
      this.searchActive = false;
    },
    openSearch: function() {
      this.searchActive = true;
      this.$nextTick(() => this.$refs.searchInput.focus())
    }
  },
  props: {
    eventName: {
      type: String,
      required: true,
    },
  },
  created: function () {
    this.$parent.$on("resetSearch", this.resetSearch);
    this.$parent.$on("openSearch", this.openSearch);
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

.search-bar {
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: 1px solid theme.$text-secondary-color;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px 4px;
}

.search-bar input {
  outline: none;
  border: none;
  width: 100%;
  margin-left: 6px;
  margin-right: 4px;
}
.search-bar > i {
  color: theme.$text-secondary-color
}
.search-bar .icon-close, .search-bar .icon-search {
  cursor: pointer;
  font-size: 24px;
}

.search-bar .icon-close {
  margin-right: 6px;
}

.search-bar .icon-search {
  margin-left: 6px;
}

@media (min-width: 768px) {   
  .search-bar {
    margin: initial;
  }
}
</style>